import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { switchMap, mergeMap, tap, catchError } from 'rxjs/operators';
import { LoginService } from "../../login/login.service"
import { ToastrService } from 'ngx-toastr';
import { formatDate, Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { isNullOrEmpty, isNullOrUndefined, isNullOrUndefinedNumber, isNullOrUndefinedObject } from '../validation';
import { UserInfoService } from '../../user-info/user-info.service';

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  static sService = 'Service/';
  static sMccldService = 'MccldService/';

  // webServiceUrl = "http://localhost:50889/WebService/";
  // applicationServiceUrl = "http://localhost:52488/WebService/";
  // FileUploadURL = "http://localhost:50222/FileUploader.ashx";

 // static webServiceUrl = 'https://localhost:7000/api/service/';
  static webServiceUrl = 'https://cfss.camfil.net/CFSSWebService/WebService/';  // live
  static applicationServiceUrl_Tieto = "https://cfss.camfil.net/CFSSApplicationServices/WebService/"  // tieto
  //static applicationServiceUrl = 'https://localhost:7153/api/'; //localhost
  //static applicationServiceUrl = 'https://cfssapplicationservices.azurewebsites.net/api/';    // Azure DEV
  static applicationServiceUrl = 'https://cfssapplicationservices-prod.azurewebsites.net/api/'; // Azure PROD

  
  //static FileUploadURL = 'https://localhost:7153/api/';
   static FileUploadURL = 'https://cfss.camfil.net/fileuploader/FileUploader.ashx'; // live

  // FileUploadURL = "https://cfss.camfil.net/fileuploader/FileUploader.ashx"; // live
  // webServiceUrl = "https://cfss.camfil.net/CFSSWebService/WebService/";  
  //applicationServiceUrl = "https://cfss.camfil.net/CFSSApplicationServices/WebService/";
  filterPhotoPath = 'https://cfss.camfil.net/cfss2/picture/';

  ApplicationID = 24;
  unitId_SI = 1;
  unitId_US = 2;
  unit_SI = "SI";
  unit_US = "US";
  FormatNumId_SI = 1;
  FormatNumId_US = 2;
  FormatDesc_SI = 'European Number Format(123 456,00)';
  FormatDesc_US = 'US / Asian Number Format(123,456.00)';
  ConcencDesc_ppb = 'ppb';
  ConcencDesc_ugm3 = 'µg/m³';
  ConcencDesc_mgm3 = 'mg/m³';
  airflowUnit_m3h = 'm³/h';
  airflowUnit_CFM = 'CFM';

  selUnit: any;

  token = this.loginService.cookieSvc.get("CFSSLoginCode");
  userBrowser = "";
  clickOnMoreOptionsBtn = false;
  blnLoadDataEntriesAPI = false;
  ServerDataReady = false;

  UploadingEntry = false;
  TempStringStorageID = "";
  TempStringStorageTotalSeq = 0;
  TempStringStorageCurrentSeq = 0;
  TempStringStorageTotalPass = 0;
  TempStringStorageTotalFail = 0;
  TempStringStorageProcessName = "";
  TempStringStorageStr = "";

  dataEntriesList: any;
  AllFilesAndFolders: any;
  AllRecentFiles: any;
  unitInfoSI: any;
  unitInfoUS: any;
  importXMLData: any;
  loadFromDatabase: any;

  LoadingXML = false;
  projectNotCalc = false;
  GoToUsersClickPath = false;
  SavedUserClickPath: any = [];

  currentFolderID = 0;

  chemfilterfromserver: any;
  colContaminationTypeFromServer: any;
  AMCChemical: any;
  FilterChemicals: any;
  ApplicationChemicalList: any;
  ApplicationContaminationFromServer: any; //Modified by PS(2023-03-22): MCCLD 2023-Fetch Chemical List-START
  OthersRecord: any;
  UserCanUseExcel: any;
  AMCMolecularClassByChemical: any;
  AstmChemicalMediaList: any;
  ChemicalFilters: any;
  AMCMolecularClass: any;

  ProjectToEdit = {
    id: 0,
    name: "Project"
  }

  showSaveButton: boolean;
  VisibleSaveClass = "HideSaveClass";
  errPage = '';

  ServerData = undefined;

  blnCreateNewProject = false;
  blnLoadFromRecord = false;
  blnLoadSolutionRec = false;
  headerProjectName = "";
  previousClickedDataList = "";

  calculationType = "";  //Modified by JW(2022-08-16): select calculation type
  finishedLoadingFilterFlag = false; // Modified by JW(2022-08-23): to indicate filter list is ready

  CalculateMCCLDCompleted = false;
  CalculationInProgress = false; //Modified by PP(2022-11-10) : To stop solutions page into checking validation automatically. Must go through NgOnDestroy

  //Modified by PS(2023-03-22): MCCLD 2023-Fetch Chemical List-START
  /*  listData = {
      ApplicationChemicalList: [],
      ChemicalFilters: {},
      UserCanUseExcel: false,
      AstmGasList:[],   //Modified by JW(2022-08-19): retrieve astm gases list before fetch filter group api to fasten the selection list
      AstmChemicalMediaList: {},
      AMCMolecularClass: {},
      ApplicationContaminationFromServer: {
        AMCChemical: [{}],
        CLDAppChemicalList: [{
          ApplicationID: 0,
          Application: "",
          ChemicalList: []
        }],
        ContaminationType: [{}],
        CLDSaveOthersRecord: [{}]
      }
    };*/
  listData = {
    ChemicalFilters: {},
    UserCanUseExcel: false,
    AstmGasList: [],   //Modified by JW(2022-08-19): retrieve astm gases list before fetch filter group api to fasten the selection list
    AstmChemicalMediaList: {},
    AMCMolecularClass: {},
  };
  //Modified by PS(2023-03-22): MCCLD 2023-Fetch Chemical List-END


  currentIndexForOtherGas: number;
  ppbForMgm3 = false;

  EnableMultiGasCalculation = false;//Modified by PP(2023-02-09) : To cater for not getting multi gas alrogrithm
  FromProgramSettings = false; //Modified by PP(2023-02-28) : If click on new project then go back to Home -> Program settings, title becomes Untitled Project
  UserInfoMode: boolean = false;
  PathStringFromHomeComponent = '';
  loadFilterListForSolsPage = false;
  //Modified by PS(2023-03-21): MCCLD 2023-Fetch Products-START
  totalLoadedFilterGrouping = 0;
  totalFilterGrouping = 0;
  //Modified by PS(2023-03-21): MCCLD 2023-Fetch Products-END

  OtherGasIDToSave = [];
  AutoSave = false;
  FinishedAutoSaveToDB = false;
  autoSaveProject = undefined;
  autoSaveDefaultProjectName = 'Last project - auto save';
  projectEditName = '';   //Modified by JW(2023-06-06):change Save / Save As messages (follow CREO4 RNDS116 Log#57)
  checkUncheckLabel = 'Check all'; //Modified by PP(2023-06-16) : Add Check All button
  invalidLoginMessage: string = ""; //Modified by PP(2023-10-24): Check for timeout of logincode
  //preventInfinityLoopInHomeComponent = false; //Modified by PP(2023-10-24): Check for timeout of logincode
  CalculationForEfficiencyFailed = false; //Modified by PP(2024-06-11) : To pop up message when lifetime is all negative/zeros

  constructor(
    private httpService: HttpClient,
    private loginService: LoginService,
    private toastr: ToastrService,
    public route: ActivatedRoute,
    private userInfoService: UserInfoService,
    private router: Router) { }

  handleError(error: HttpErrorResponse) {
    let errorMessage = 'Unknown error!';
    if (error.error instanceof ErrorEvent) {
      // Client-side errors
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // Server-side errors
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(errorMessage);
  }

  detectUserBrowser() {
    const agent = window.navigator.userAgent.toLowerCase()
    switch (true) {
      case agent.indexOf('edg') > -1:
        this.userBrowser = 'edge';
        break;
      case agent.indexOf('opr') > -1 && !!(<any>window).opr:
        this.userBrowser = 'opera';
        break;
      case agent.indexOf('chrome') > -1 && !!(<any>window).chrome:
        this.userBrowser = 'chrome';
        break;
      case agent.indexOf('trident') > -1:
        this.userBrowser = 'ie';
        break;
      case agent.indexOf('firefox') > -1:
        this.userBrowser = 'firefox';
        break;
      case agent.indexOf('safari') > -1:
        this.userBrowser = 'safari';
        break;
      default:
        this.userBrowser = 'other';
        break;
    }
  }

  CreateNewFolder(pFolderID: number, pFolderName: string): Observable<any> {
    let params = {
      ApplicationID: this.ApplicationID,
      UserID: this.userInfoService.userData.UserId.toString(),
      Username: this.userInfoService.userData.UserName.toString(),
      //Code: this.token,
      Code: this.loginService.cookieSvc.get("CFSSLoginCode"), //Modified by PP(2023-10-24): Check for timeout of logincode
      FolderID: pFolderID,
      FolderName: pFolderName,
      ParentID: pFolderID,
      LanguageID: this.userInfoService.userData.LanguageId.toString()
    };
    return this.httpService.post(SharedService.applicationServiceUrl + SharedService.sService + "CreateApplicationFolder", params);
  }

  getRecentProjects(): Observable<any> {
    let params = {
      ApplicationID: this.ApplicationID,
      UserID: this.userInfoService.userData.UserId.toString(),
      Username: this.userInfoService.userData.UserName.toString(),
      //Code: this.token
      Code: this.loginService.cookieSvc.get("CFSSLoginCode") //Modified by PP(2023-10-24): Check for timeout of logincode
    };
    return this.httpService.post(SharedService.applicationServiceUrl + SharedService.sService + "GetRecentProjects", params).pipe(catchError(this.handleError));
  }

  getProjectDropdowns(unitid: number): Observable<any> {
    let userID = this.userInfoService.userData.UserId;
    let regionID = this.userInfoService.userData.RegionId;
    let languageID = this.userInfoService.userData.LanguageId;
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let params = {
      'UserID': userID,
      'ApplicationID': this.ApplicationID,
      'RegionID': regionID,
      'LanguageID': languageID,
      'LoginCode': this.loginService.cookieSvc.get("CFSSLoginCode"),
      'UnitID': this.userInfoService.userData.UserUnitId
    }
    return this.httpService.post(SharedService.applicationServiceUrl + SharedService.sMccldService + 'MCCLDOnlineDDLSelection', params).pipe(catchError(this.handleError));
  }

  RetrieveDDL() {
    //console.log("1. start to call backend to retreive DDL" + new Date());
    console.log("PS20230321 Check: => get ddl and default value -START => " + new Date());
    this.getProjectDropdowns(this.userInfoService.userData.UserUnitId).subscribe(ddlist => {
      //console.log("2. DDL returned from backend API " + new Date());
      console.log("PS20230321 Check: => get ddl and default value -END => " + new Date());
      if (ddlist !== null) {
        if (ddlist !== undefined) {
          this.dataEntriesList = ddlist.General;
          if (this.userInfoService.userData.UserUnitName === this.unit_SI) {
            this.selUnit = this.dataEntriesList.UnitInfoClass.UnitInfo_SI;
          } else {
            this.selUnit = this.dataEntriesList.UnitInfoClass.UnitInfo_US;
          }
          this.blnLoadDataEntriesAPI = true;
          console.log("PS20230321 Check: => assign ddl and default value to front end class -START => " + new Date());
          this.listData = this.getDataListPerUserUnit(this.userInfoService.userData.UserUnitId);
          this.listData.UserCanUseExcel = ddlist.UserCanUseExcel;
          //Modified by PS(2023-03-21): MCCLD 2023-Fetch Products-START
          /*this.listData. = ddlist.ApplicationContamination;
          this.getApplicationwithChemicalsList();
          this.AMCMolecularClassByChemical = ddlist.AMCMolecularClassByChemical;*/
          //Modified by PS(2023-03-21): MCCLD 2023-Fetch Products-END

          //Modified by PP(2023-04-03) : AMCMolecularClass, AstmChemicalMediaList and ChemicalFilters always missing - START
          if (this.listData.AMCMolecularClass === undefined) {
            var AMCMolClass = [];
            if (this.AMCMolecularClass != undefined) {
              for (var i = 0; i < this.AMCMolecularClass.length; i++) {
                let tmpEachRec = this.AMCMolecularClass[i];
                AMCMolClass.push(tmpEachRec);
              }
              this.listData.AMCMolecularClass = AMCMolClass;
            }
            //this.listData.AMCMolecularClass = this.AMCMolecularClass;
          }

          if (this.listData.AstmChemicalMediaList === undefined) {
            var AstmChemMediaList = [];
            if (this.AstmChemicalMediaList != undefined) {
              for (var i = 0; i < this.AstmChemicalMediaList.length; i++) {
                let tmpEachRec = this.AstmChemicalMediaList[i];
                AstmChemMediaList.push(tmpEachRec);
              }
              this.listData.AstmChemicalMediaList = AstmChemMediaList;
              //this.listData.AstmChemicalMediaList = this.AstmChemicalMediaList;
            }
          }

          if (this.listData.ChemicalFilters === undefined) {
            var chemFilterList = [];
            if (this.ChemicalFilters != undefined) {
              for (var i = 0; i < this.ChemicalFilters.length; i++) {
                let tmpEachRec = this.ChemicalFilters[i];
                chemFilterList.push(tmpEachRec);
              }
              this.listData.ChemicalFilters = chemFilterList;
              //this.listData.ChemicalFilters = this.ChemicalFilters;
            }
          }
          //Modified by PP(2023-04-03) : AMCMolecularClass, AstmChemicalMediaList and ChemicalFilters always missing - END

          console.log("PS20230321 Check: => assign ddl and default value to front end class -END => " + new Date());
        }
      } else {
        this.redirectToLoginPage();
      }
    });
    //Modified by PS(2023-03-22): MCCLD 2023-Fetch Chemical List-START
    if (this.ApplicationContaminationFromServer === undefined) {
      this.FetchContamination_FilterGrouping();
    }
    //Modified by PS(2023-03-22): MCCLD 2023-Fetch Chemical List-END

  }

  //Modified by PS(2023-03-21): MCCLD 2023-Fetch Products-START
  /*FetchContamination_FilterGrouping () {
    this.loadFilterListForSolsPage = true;
    //console.log("A) start to call 2nd API to fetchFilterGroup " + new Date() );
    console.log("PS20230321 Check: => fetch filter group -START => "   + new Date());
    this.fetchFilterGrouping().subscribe(result => {
      if(result !== undefined && result !== null) {
       // console.log("B) result back from 2nd API " + new Date());
       console.log("PS20230321 Check: => fetch filter group -END => "   + new Date());
        this.chemfilterfromserver = result;
        //this.AMCMolecularClassByChemical = this.chemfilterfromserver.AMCMolecularClassByChemical;
        this.FilterChemicals = this.chemfilterfromserver.FilterChemicals;
      }
      console.log("PS20230321 Check: => Assign filters to front end class -START => "   + new Date());
      //console.log("C) start to put data into classes " + new Date());
      let ChemicalFilters = [];
      //Get Chemical List
      let Chemicals = <any> [];
      let ary = this.AMCChemical;
      ary.sort((a, b) => parseFloat(a.ChemicalID) - parseFloat(b.ChemicalID));
      for (let a = 0; a < ary.length; a++) {
        Chemicals.push(ary[a].ChemicalID);
      }

      let b = 0;
      for (let b = 0; b < Chemicals.length; b++) {
        let id = Chemicals[b];
        let chemicalFilters = {
          ChemicalID: id,
           Groups: <any> []
        }
        for (let j = 0; j < this.FilterChemicals.length; j++) {
          let tmpGroup = this.FilterChemicals[j];
            chemicalFilters.Groups.push(tmpGroup);
        }
        ChemicalFilters.push(chemicalFilters);
      }
      //Modified by JW(2022-07-15): fetch contamination and application lists when retrieve general DDL-start
      // this.OthersRecord = this.chemfilterfromserver.CLDSaveOthersRecord;
      //Modified by JW(2022-07-15): fetch contamination and application lists when retrieve general DDL-end

      //console.log("Ca) start to put data into classes " + new Date());
      var chemList = [];
      var a = 0;
      for (a= 0; a < this.AMCMolecularClassByChemical.length; a++){
        var tmpChem = this.AMCMolecularClassByChemical[a];
        if (tmpChem.ASTMWeight !== null && tmpChem.ASTMVolume !== null && tmpChem.ASTMWeight > 0 && tmpChem.ASTMVolume > 0 ) {
          chemList.push(tmpChem);
        }
      }

      if (chemList.length > 0) {
        var tmpChemID = 0;
        var chemicalMediaElement;
        var foundSubstanceName = false;
        this.AstmChemicalMediaList = [];

        for (let b = 0; b < chemList.length; b++) {
          tmpChemID = chemList[b].ChemicalID;
          let existChemID = false;
          let toreplaceArray = false;
          let index = 0;
          if (this.AstmChemicalMediaList.length > 0) {
            index = this.AstmChemicalMediaList.findIndex(x => x.ChemID === tmpChemID);
            if (index > -1) {
              existChemID = true;
              foundSubstanceName = true;
              toreplaceArray = true;
              chemicalMediaElement = this.AstmChemicalMediaList[index];
            }
          }

          if (existChemID === false) {
            chemicalMediaElement = {
            ChemID: tmpChemID,
            ChemName: "",
            pbb: 0,
            Media: <any> []
            };
            //find chemical name
            var c = 0;
            for (c = 0; c < this.colContaminationTypeFromServer.length; c++) {
              if (tmpChemID === this.colContaminationTypeFromServer[c].ChemicalID) {
                chemicalMediaElement.ChemName = this.colContaminationTypeFromServer[c].substance;
                foundSubstanceName = true;
                break;
              }
            }
          }

          //find media name
          let tempmedia = {
            id: 0,
            medianame: "",
            mediadbname: "",
            astmVol: 0,
            astmWeight: 0
          };
          tempmedia.id = chemList[b].FilterID;
          tempmedia.astmVol = chemList[b].ASTMVolume;
          tempmedia.astmWeight = chemList[b].ASTMWeight;

          let found=false;
          if (foundSubstanceName) {
            var d = 0;
            for (d = 0; d < this.FilterChemicals.length; d++) {
              var e = 0;
              var tmpFilterChemical = this.FilterChemicals[d];
              for (e = 0; e < tmpFilterChemical.Types.length; e++) {
                var tmpFilterChemType = tmpFilterChemical.Types[e];
                var ind = tmpFilterChemType.Moleculars.findIndex(x => x.MolecularID === tempmedia.id)
                if (ind > -1) {
                  tempmedia.medianame = this.FilterChemicals[d].Types[e].Moleculars[ind].MediaName;
                  tempmedia.mediadbname = this.FilterChemicals[d].Types[e].Moleculars[ind].MolecularName;
                  found = true;
                  break;
                }
              }
              if (found === true) {
                break;
              }
            }
          }
          //Modified by JW(2021-11-12): ASTM empty media appear in the list if no record in dbo.filtertypefilter-start
          let media = {};
          if (found === true) {
            media = { Id: tempmedia.id, MediaName: tempmedia.medianame, MediaDBName: tempmedia.mediadbname, ASTMVolume: tempmedia.astmVol, ASTMWeight: tempmedia.astmWeight };
          }
          //Modified by JW(2021-11-12): ASTM empty media appear in the list if no record in dbo.filtertypefilter-end

          chemicalMediaElement.Media.push(media);
          if (toreplaceArray === true) {
            this.AstmChemicalMediaList.splice(index, 1, chemicalMediaElement);
          } else {
            this.AstmChemicalMediaList.push(chemicalMediaElement);
          }
        }
      }

      // Put All Filters Group into Correct Position
      //console.log("Cb) start to put data into classes " + new Date());
      let CorrectMoleculars = [];
      let tmpChemicalFilters;
      tmpChemicalFilters = ChemicalFilters;
      let AMCMolecularClassByChemical = this.AMCMolecularClassByChemical;
      this.ChemicalFilters = [];
      if (tmpChemicalFilters != undefined || tmpChemicalFilters.length > 0) {
        for (let i = 0; i < tmpChemicalFilters.length; i++) {
          let chemicalFiltersElement = {
            ChemicalID: tmpChemicalFilters[i].ChemicalID,
            Groups: <any> [],
          };
          let groups = tmpChemicalFilters[i].Groups;
          let CorrectGroups:any = [];

          if (groups != undefined && groups.length > 0) {
            for (let j = 0; j < groups.length; j++) {
              let group = groups[j];
              let CorrectTypes:any = [];
              if (group.Types != undefined && group.Types.length > 0) {
                CorrectTypes = [];
                for (let k = 0; k < group.Types.length; k++) {
                  let type = group.Types[k];
                  if (type.Moleculars != undefined && type.Moleculars.length > 0) {
                    CorrectMoleculars = [];
                    for (let l = 0; l < type.Moleculars.length; l++) {
                      let molecular = type.Moleculars[l];
                      for (let m = 0; m < AMCMolecularClassByChemical.length; m++) {
                        if (AMCMolecularClassByChemical[m].ChemicalID === tmpChemicalFilters[i].ChemicalID && AMCMolecularClassByChemical[m].FilterID === molecular.MolecularID) {
                          let tmpMolecular = molecular;
                          CorrectMoleculars.push(tmpMolecular);
                        }
                      }
                    }

                    if (CorrectMoleculars.length > 0) {
                      let tmpType = {
                        MolecularTypeID: type.MolecularTypeID,
                        MolecularType: type.MolecularType,
                        MolecularGroupID: type.MolecularGroupID,
                        TotalChild:0,
                        InputSize: type.InputSize,
                        SingleStage: type.SingleStage,
                        Moleculars:<any>[]
                      };
                      tmpType.TotalChild = CorrectMoleculars.length;
                      for (let e = 0; e < CorrectMoleculars.length; e++) {
                        let molecularData = CorrectMoleculars[e];
                        let tmpMolecular2 = {
                          MolecularID: molecularData.MolecularID,
                          MolecularName: molecularData.MolecularName,
                          MolecularDisplayName: molecularData.MolecularDisplayName,
                          MolecularTypeID: molecularData.MolecularTypeID,
                          MolecularType: molecularData.MolecularType,
                          MolecularGroupID: molecularData.MolecularGroupID,
                          MolecularGroup: molecularData.MolecularGroup, //Modified by PP(2022-09-05) : Add Molecular Group Name
                          MolecularTypeMolecularID: molecularData.MolecularTypeMolecularID,
                          BedDepth: molecularData.BedDepth,
                          BulkDens: molecularData.BulkDens,
                          Diameter: molecularData.Diameter,
                          FrontArea: molecularData.FrontArea,
                          MediaWeight: molecularData.MediaWeight,
                          MolecularTypePic: molecularData.MolecularTypePic,
                          MolecularPic: molecularData.MolecularPic,
                          PaFormula: molecularData.PaFormula,
                          TotalWeight: molecularData.TotalWeight,
                          Volume: molecularData.Volume
                        };

                        //Modified by PP(2022-09-21) : Follow CLD 2.0 : CLD 3.0 MVP1.0 - If record found in ownersetting, this user is an admin - START
                        if (tmpMolecular2.MolecularDisplayName == '') {
                          tmpMolecular2.MolecularDisplayName = tmpMolecular2.MolecularName
                        }
                        //Modified by PP(2022-09-21) : Follow CLD 2.0 : CLD 3.0 MVP1.0 - If record found in ownersetting, this user is an admin - END

                        tmpType.Moleculars.push(tmpMolecular2);
                      }
                      CorrectTypes.push(tmpType);
                    }
                  }
                }
              }

              if (CorrectTypes.length > 0) {
                var tmpGroup2 = {
                  MolecularGroupID: group.MolecularGroupID,
                  MolecularGroup: group.MolecularGroup,
                  TotalChild: 0,
                  Types: <any> [],
                };

                tmpGroup2.TotalChild = CorrectTypes.length;
                for (var f = 0; f < CorrectTypes.length; f++) {
                  var molecularTypeData = CorrectTypes[f];
                  var tmpType2 = {
                    MolecularTypeID: molecularTypeData.MolecularTypeID,
                    MolecularType: molecularTypeData.MolecularType,
                    MolecularGroupID: molecularTypeData.MolecularGroupID,
                    TotalChild: 0,
                    InputSize: molecularTypeData.InputSize,
                    SingleStage: molecularTypeData.SingleStage,
                    Moleculars: [],
                  };
                  tmpType2.Moleculars = molecularTypeData.Moleculars;
                  tmpType2.TotalChild = tmpType2.Moleculars.length;
                  tmpGroup2.Types.push(tmpType2);
                }
                CorrectGroups.push(tmpGroup2);
              }
            }
          }

          if (CorrectGroups.length > 0) {
            for (var d = 0; d < CorrectGroups.length; d++) {
              chemicalFiltersElement.Groups.push(CorrectGroups[d]);
            }
            this.ChemicalFilters.push(chemicalFiltersElement);
          }
        }
      }
      let timstamp = new Date();
      //console.log("D) finished putting data into classes " + timstamp);

      var tmp;
      tmp = this.AMCMolecularClassByChemical.sort((a, b) => parseFloat(a.FilterID) - parseFloat(b.FilterID));
      this.AMCMolecularClass = tmp;
      this.listData.AstmChemicalMediaList = this.AstmChemicalMediaList;
      this.listData.ChemicalFilters = this.ChemicalFilters;
      this.listData.AMCMolecularClass = this.AMCMolecularClass;
      this.finishedLoadingFilterFlag = true;
      this.loadFilterListForSolsPage = false;
      console.log("this.finishedLoadingFilterFlag => " + this.finishedLoadingFilterFlag);
      console.log("PS20230321 Check: => Assign filters to front end class -END => "   + new Date());
    });
  }

   fetchFilterGrouping() {
    let params = {
      'ApplicationID': this.ApplicationID,
      'UserID': this.userInfoService.userData.UserId,
      'Username' : this.userInfoService.userData.UserName,
      'RegionID': this.userInfoService.userData.RegionId,
      'Code': this.loginService.cookieSvc.get("CFSSLoginCode"),
      'LanguageID': this.userInfoService.userData.LanguageId,
      'IsEN1822Filter' : false,
      'System': ""
      }
    return this.httpService.post(this.applicationServiceUrl + 'LoadMolecularFilterGroup', params );
  }
  */

  AssignChemicalFilterListToClass() {
    let ChemicalFilters = [];

    let Chemicals = <any>[];
    let ary = this.AMCChemical;
    ary.sort((a, b) => parseFloat(a.ChemicalID) - parseFloat(b.ChemicalID));
    for (let a = 0; a < ary.length; a++) {
      Chemicals.push(ary[a].ChemicalID);
    }

    let b = 0;
    for (let b = 0; b < Chemicals.length; b++) {
      let id = Chemicals[b];
      let chemicalFilters = {
        ChemicalID: id,
        Groups: <any>[]
      }
      for (let j = 0; j < this.FilterChemicals.length; j++) {
        let tmpGroup = this.FilterChemicals[j];
        chemicalFilters.Groups.push(tmpGroup);
      }
      ChemicalFilters.push(chemicalFilters);
    }

    var chemList = [];
    var a = 0;
    for (a = 0; a < this.AMCMolecularClassByChemical.length; a++) {
      var tmpChem = this.AMCMolecularClassByChemical[a];
      if (tmpChem.ASTMWeight !== null && tmpChem.ASTMVolume !== null && tmpChem.ASTMWeight > 0 && tmpChem.ASTMVolume > 0) {
        chemList.push(tmpChem);
      }
    }

    if (chemList.length > 0) {
      var tmpChemID = 0;
      var chemicalMediaElement;
      var foundSubstanceName = false;
      this.AstmChemicalMediaList = [];

      for (let b = 0; b < chemList.length; b++) {
        tmpChemID = chemList[b].ChemicalID;
        let existChemID = false;
        let toreplaceArray = false;
        let index = 0;
        if (this.AstmChemicalMediaList.length > 0) {
          index = this.AstmChemicalMediaList.findIndex(x => x.ChemID === tmpChemID);
          if (index > -1) {
            existChemID = true;
            foundSubstanceName = true;
            toreplaceArray = true;
            chemicalMediaElement = this.AstmChemicalMediaList[index];
          }
        }

        if (existChemID === false) {
          chemicalMediaElement = {
            ChemID: tmpChemID,
            ChemName: "",
            pbb: 0,
            Media: <any>[]
          };
          //find chemical name
          var c = 0;
          for (c = 0; c < this.colContaminationTypeFromServer.length; c++) {
            if (tmpChemID === this.colContaminationTypeFromServer[c].ChemicalID) {
              chemicalMediaElement.ChemName = this.colContaminationTypeFromServer[c].substance;
              foundSubstanceName = true;
              break;
            }
          }
        }

        //find media name
        let tempmedia = {
          id: 0,
          medianame: "",
          mediadbname: "",
          astmVol: 0,
          astmWeight: 0
        };
        tempmedia.id = chemList[b].FilterID;
        tempmedia.astmVol = chemList[b].ASTMVolume;
        tempmedia.astmWeight = chemList[b].ASTMWeight;

        let found = false;
        if (foundSubstanceName) {
          var d = 0;
          for (d = 0; d < this.FilterChemicals.length; d++) {
            var e = 0;
            var tmpFilterChemical = this.FilterChemicals[d];
            for (e = 0; e < tmpFilterChemical.Types.length; e++) {
              var tmpFilterChemType = tmpFilterChemical.Types[e];
              var ind = tmpFilterChemType.Moleculars.findIndex(x => x.MolecularID === tempmedia.id)
              if (ind > -1) {
                tempmedia.medianame = this.FilterChemicals[d].Types[e].Moleculars[ind].MediaName;
                tempmedia.mediadbname = this.FilterChemicals[d].Types[e].Moleculars[ind].MolecularName;
                found = true;
                break;
              }
            }
            if (found === true) {
              break;
            }
          }
        }
        //Modified by JW(2021-11-12): ASTM empty media appear in the list if no record in dbo.filtertypefilter-start
        let media = {};
        if (found === true) {
          media = { Id: tempmedia.id, MediaName: tempmedia.medianame, MediaDBName: tempmedia.mediadbname, ASTMVolume: tempmedia.astmVol, ASTMWeight: tempmedia.astmWeight };
        }
        //Modified by JW(2021-11-12): ASTM empty media appear in the list if no record in dbo.filtertypefilter-end

        chemicalMediaElement.Media.push(media);
        if (toreplaceArray === true) {
          this.AstmChemicalMediaList.splice(index, 1, chemicalMediaElement);
        } else {
          this.AstmChemicalMediaList.push(chemicalMediaElement);
        }
      }
    }

    // Put All Filters Group into Correct Position
    //console.log("Cb) start to put data into classes " + new Date());
    let CorrectMoleculars = [];
    let tmpChemicalFilters;
    tmpChemicalFilters = ChemicalFilters;
    let AMCMolecularClassByChemical = this.AMCMolecularClassByChemical;
    this.ChemicalFilters = [];
    if (tmpChemicalFilters != undefined || tmpChemicalFilters.length > 0) {
      for (let i = 0; i < tmpChemicalFilters.length; i++) {
        let chemicalFiltersElement = {
          ChemicalID: tmpChemicalFilters[i].ChemicalID,
          Groups: <any>[],
        };
        let groups = tmpChemicalFilters[i].Groups;
        let CorrectGroups: any = [];

        if (groups != undefined && groups.length > 0) {
          for (let j = 0; j < groups.length; j++) {
            let group = groups[j];
            let CorrectTypes: any = [];
            if (group.Types != undefined && group.Types.length > 0) {
              CorrectTypes = [];
              for (let k = 0; k < group.Types.length; k++) {
                let type = group.Types[k];
                if (type.Moleculars != undefined && type.Moleculars.length > 0) {
                  CorrectMoleculars = [];
                  for (let l = 0; l < type.Moleculars.length; l++) {
                    let molecular = type.Moleculars[l];
                    for (let m = 0; m < AMCMolecularClassByChemical.length; m++) {
                      if (AMCMolecularClassByChemical[m].ChemicalID === tmpChemicalFilters[i].ChemicalID && AMCMolecularClassByChemical[m].FilterID === molecular.MolecularID) {
                        //Modified by Pinky(2026-06-26) Filter selection to exclude 0ltc #134239 - START
                        //let tmpMolecular = molecular;
                        //CorrectMoleculars.push(tmpMolecular);
                        if (AMCMolecularClassByChemical[m].LTCNO > 0) {
                          let tmpMolecular = molecular;
                          CorrectMoleculars.push(tmpMolecular);
                        }
                      //Modified by Pinky(2026-06-26) Filter selection to exclude 0ltc #134239 - END
                      }
                    }
                  }

                  if (CorrectMoleculars.length > 0) {
                    let tmpType = {
                      MolecularTypeID: type.MolecularTypeID,
                      MolecularType: type.MolecularType,
                      MolecularGroupID: type.MolecularGroupID,
                      TotalChild: 0,
                      InputSize: type.InputSize,                      
                      SingleStage: type.SingleStage,
                      Moleculars: <any>[]
                    };
                    tmpType.TotalChild = CorrectMoleculars.length;
                    for (let e = 0; e < CorrectMoleculars.length; e++) {
                      let molecularData = CorrectMoleculars[e];
                      let tmpMolecular2 = {
                        MolecularID: molecularData.MolecularID,
                        MolecularName: molecularData.MolecularName,
                        MolecularDisplayName: molecularData.MolecularDisplayName,
                        MolecularTypeID: molecularData.MolecularTypeID,
                        MolecularType: molecularData.MolecularType,
                        MolecularGroupID: molecularData.MolecularGroupID,
                        MolecularGroup: molecularData.MolecularGroup, //Modified by PP(2022-09-05) : Add Molecular Group Name
                        MolecularTypeMolecularID: molecularData.MolecularTypeMolecularID,
                        BedDepth: molecularData.BedDepth,
                        BulkDens: molecularData.BulkDens,
                        Diameter: molecularData.Diameter,
                        FrontArea: molecularData.FrontArea,
                        MediaWeight: molecularData.MediaWeight,
                        MolecularTypePic: molecularData.MolecularTypePic,
                        MolecularPic: molecularData.MolecularPic,
                        //PaFormula: molecularData.PaFormula, //pplim exclude
                        TotalWeight: molecularData.TotalWeight,
                        Volume: molecularData.Volume
                      };

                      //Modified by PP(2022-09-21) : Follow CLD 2.0 : CLD 3.0 MVP1.0 - If record found in ownersetting, this user is an admin - START
                      if (tmpMolecular2.MolecularDisplayName == '') {
                        tmpMolecular2.MolecularDisplayName = tmpMolecular2.MolecularName
                      }
                      //Modified by PP(2022-09-21) : Follow CLD 2.0 : CLD 3.0 MVP1.0 - If record found in ownersetting, this user is an admin - END

                      tmpType.Moleculars.push(tmpMolecular2);
                    }
                    CorrectTypes.push(tmpType);
                  }
                }
              }
            }

            if (CorrectTypes.length > 0) {
              var tmpGroup2 = {
                MolecularGroupID: group.MolecularGroupID,
                MolecularGroup: group.MolecularGroup,
                TotalChild: 0,
                Types: <any>[],
              };

              tmpGroup2.TotalChild = CorrectTypes.length;
              for (var f = 0; f < CorrectTypes.length; f++) {
                var molecularTypeData = CorrectTypes[f];
                var tmpType2 = {
                  MolecularTypeID: molecularTypeData.MolecularTypeID,
                  MolecularType: molecularTypeData.MolecularType,
                  MolecularGroupID: molecularTypeData.MolecularGroupID,
                  TotalChild: 0,
                  InputSize: molecularTypeData.InputSize,                  
                  SingleStage: molecularTypeData.SingleStage,
                  Moleculars: [],
                };
                tmpType2.Moleculars = molecularTypeData.Moleculars;
                tmpType2.TotalChild = tmpType2.Moleculars.length;
                tmpGroup2.Types.push(tmpType2);
              }
              CorrectGroups.push(tmpGroup2);
            }
          }
        }

        if (CorrectGroups.length > 0) {
          for (var d = 0; d < CorrectGroups.length; d++) {
            chemicalFiltersElement.Groups.push(CorrectGroups[d]);
          }
          this.ChemicalFilters.push(chemicalFiltersElement);
        }
      }
    }
    let timstamp = new Date();


    var tmp;
    tmp = this.AMCMolecularClassByChemical.sort((a, b) => parseFloat(a.FilterID) - parseFloat(b.FilterID));
    this.AMCMolecularClass = tmp;
    this.listData.AstmChemicalMediaList = this.AstmChemicalMediaList;
    this.listData.ChemicalFilters = this.ChemicalFilters;
    this.listData.AMCMolecularClass = this.AMCMolecularClass;
    this.finishedLoadingFilterFlag = true;
    this.loadFilterListForSolsPage = false;
    console.log("this.finishedLoadingFilterFlag => " + this.finishedLoadingFilterFlag);
  }

  //pplim 20250822: call api one-time only
  // FetchFilterGroupingByFilterGroupID(pFilterGroupID) {
  //   this.chemfilterfromserver = { FilterChemicals: [] };
  //   this.FilterChemicals = [];

  //   console.log("PS20230321 Check: => fetch filter group by groupId " + pFilterGroupID + " -START => " + new Date());
  //   this.fetchFilterGrouping(false, pFilterGroupID).subscribe(result => {
  //     console.log("PS20230321 Check: => fetch filter group by groupId " + pFilterGroupID + " -END => " + new Date());
  //     if (result !== undefined && result !== null) {
  //       let serverdata: any = result;
  //       //pplim todo: can do mapping here after reduce payload size
  //       this.chemfilterfromserver.FilterChemicals.push(serverdata.FilterChemicals[0]);
  //       this.totalLoadedFilterGrouping = this.totalLoadedFilterGrouping + 1;
  //     }
  //     if (this.totalFilterGrouping === this.totalLoadedFilterGrouping) {
  //       //Sort by name
  //       this.chemfilterfromserver.FilterChemicals.sort(function (a, b) {
  //         if (a.MolecularGroup < b.MolecularGroup) { return -1; }
  //         if (a.MolecularGroup > b.MolecularGroup) { return 1; }
  //         return 0;
  //       })
  //       this.FilterChemicals = this.chemfilterfromserver.FilterChemicals;
  //       console.log("PS20230321 Check: => Assign filters to front end class -START => " + new Date());
  //       this.AssignChemicalFilterListToClass();
  //       console.log("PS20230321 Check: => Assign filters to front end class -END => " + new Date());
  //     }
  //   });
  // }
  // FetchContamination_FilterGrouping() {
  //   this.loadFilterListForSolsPage = true;
  //   console.log("PS20230321 Check: => fetch chemical list -START => " + new Date());
  //   this.fetchChemicalList().subscribe(ddlist => {
  //     console.log("PS20230321 Check: => fetch chemical list -END => " + new Date());
  //     let ddl: any = ddlist;
  //     if (ddl !== null) {
  //       if (ddl !== undefined) {
  //         //this.listData.ApplicationContaminationFromServer = ddl.ApplicationContamination;
  //         this.ApplicationContaminationFromServer = ddl.ApplicationContamination; //Modified by PP(2023-03-22) : To cater for missing classes in listdata
  //         this.getApplicationwithChemicalsList();
  //         this.AMCMolecularClassByChemical = ddl.AMCMolecularClassByChemical;
  //         console.log("PS20230321 Check: => fetch filter group only -START => " + new Date());
  //         this.fetchFilterGrouping(true).subscribe(result => {
  //           console.log("PS20230321 Check: => fetch filter group only -END => " + new Date());
  //           if (result !== undefined && result !== null) {
  //             let serverdata: any = result;
  //             let filterChemicals = serverdata.FilterChemicals;
  //             this.totalFilterGrouping = filterChemicals.length;
  //             for (var i = 0; i < filterChemicals.length; i++) {
  //               let group = filterChemicals[i];
  //               this.FetchFilterGroupingByFilterGroupID(group.MolecularGroupID);
  //             }
  //           }
  //         });
  //       }
  //     } else {
  //       this.redirectToLoginPage();
  //     }
  //   });
  // }
  FetchContamination_FilterGrouping() {
    this.loadFilterListForSolsPage = true;
    this.fetchChemicalList().subscribe(ddlist => {
      let ddl: any = ddlist;
      if (ddl !== null) {
        if (ddl !== undefined) {
          this.ApplicationContaminationFromServer = ddl.ApplicationContamination;
          this.getApplicationwithChemicalsList();
          this.AMCMolecularClassByChemical = ddl.AMCMolecularClassByChemical;
          this.fetchFilterGrouping(false).subscribe(result => {
            if (result !== undefined && result !== null) {
              let serverdata: any = result;
              let filterChemicals = serverdata.FilterChemicals;
              this.totalFilterGrouping = filterChemicals.length;

              //pplim: reset?
              this.chemfilterfromserver = { FilterChemicals: [] };
              this.FilterChemicals = [];

              for (var i = 0; i < filterChemicals.length; i++) {
                this.chemfilterfromserver.FilterChemicals.push(filterChemicals[i]);
              }
              //Sort by name
              this.chemfilterfromserver.FilterChemicals.sort(function (a, b) {
                if (a.MolecularGroup < b.MolecularGroup) { return -1; }
                if (a.MolecularGroup > b.MolecularGroup) { return 1; }
                return 0;
              })
              this.FilterChemicals = this.chemfilterfromserver.FilterChemicals;
              this.AssignChemicalFilterListToClass();
            }
          });
        }
      } else {
        this.redirectToLoginPage();
      }
    });
  }

  fetchChemicalList() {
    let userID = this.userInfoService.userData.UserId;
    let regionID = this.userInfoService.userData.RegionId;
    let languageID = this.userInfoService.userData.LanguageId;
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let params = {
      'UserID': userID,
      'ApplicationID': this.ApplicationID,
      'RegionID': regionID,
      'LanguageID': languageID,
      'LoginCode': this.loginService.cookieSvc.get("CFSSLoginCode"),
      'UnitID': this.userInfoService.userData.UserUnitId
    }
    return this.httpService.post(SharedService.applicationServiceUrl + SharedService.sMccldService + 'MCCLDChemicalSelection', params);
  }

  fetchFilterGrouping(pGroupOnly = false, pGroupID = -1) {
    let fetchGroupOnly = pGroupOnly;
    let groupId = pGroupID;
    let params = {
      'ApplicationID': this.ApplicationID,
      'UserID': this.userInfoService.userData.UserId,
      'Username': this.userInfoService.userData.UserName,
      'RegionID': this.userInfoService.userData.RegionId,
      'Code': this.loginService.cookieSvc.get("CFSSLoginCode"),
      'pFetchGroupOnly': pGroupOnly,
      'pFilterGroupID': pGroupID
    }
    return this.httpService.post(SharedService.applicationServiceUrl + SharedService.sMccldService + 'LoadMolecularFilterGroupNew', params);
  }

  //Modified by PS(2023-03-21): MCCLD 2023-Fetch Products-END

  GetApplicationFolder(pFolderID: number, pServerDB: boolean): Observable<any> {
    let params = {
      ApplicationID: this.ApplicationID,
      UserID: this.userInfoService.userData.UserId.toString(),
      Username: this.userInfoService.userData.UserName.toString(),
      Code: this.loginService.cookieSvc.get("CFSSLoginCode"),
      ParentID: pFolderID,
      ServerDB: pServerDB,
      isNewLCC: true
    };
    return this.httpService.post(SharedService.applicationServiceUrl + SharedService.sService + "GetApplicationFolder", params).pipe(catchError(this.handleError));
  }

  assignToNewFolderStruc(pFolderID: number): any {
    let newStructure = [];
    // Folders
    for (let i = 0; i < this.AllFilesAndFolders.childFolder.length; i++) {
      if (this.AllFilesAndFolders.childFolder[i].ParentID == pFolderID) {
        // Add Folder
        var tmpRec = {};
        tmpRec = this.addToStruc(this.AllFilesAndFolders.childFolder[i], "Folder");
        newStructure.push(tmpRec);
      }
    }

    // Files
    if (this.AllFilesAndFolders.ID == pFolderID) {
      if (this.AllFilesAndFolders.Files !== null && this.AllFilesAndFolders.Files.length > 0) { //Modified by JW(2022-02-07): to solve null error
        //Add Files
        for (let j = 0; j < this.AllFilesAndFolders.Files.length; j++) {
          var tmpRec = {};
          tmpRec = this.addToStruc(this.AllFilesAndFolders.Files[j], "File");
          newStructure.push(tmpRec);
        }
      }
    }
    return newStructure;
  }

  EditFolder(pFolderID: number, pParentID: number, pFolderName: string): Observable<any> {
    let params = {
      //ApplicationID: localStorage.getItem(""),
      ApplicationID: this.ApplicationID,
      UserID: this.userInfoService.userData.UserId.toString(),
      Username: this.userInfoService.userData.UserName.toString(),
      //Code: this.token,
      Code: this.loginService.cookieSvc.get("CFSSLoginCode"),
      FolderID: pFolderID,
      FolderName: pFolderName,
      ParentID: pParentID,
      LanguageID: this.userInfoService.userData.LanguageId.toString()
    };
    return this.httpService.post(SharedService.applicationServiceUrl + SharedService.sService + "EditApplicationFolder", params);
  }

  EditFile(pAMCID: number, pNewProjName: string): Observable<any> {
    let params = {
      ApplicationID: this.ApplicationID,
      UserID: this.userInfoService.userData.UserId.toString(),
      Username: this.userInfoService.userData.UserName.toString(),
      //Code: this.token,
      Code: this.loginService.cookieSvc.get("CFSSLoginCode"),
      ProjectID: pAMCID,
      //FolderID: pFolderID,
      NewProjName: pNewProjName,
      //ParentID: pParentID,
      ServerDB: true,
      LanguageID: this.userInfoService.userData.LanguageId.toString()
    };
    return this.httpService.post(SharedService.applicationServiceUrl + SharedService.sService + "EditProjectName", params);
  }

  DeleteFile(pProjectID: number, pServerDB: boolean): Observable<any> {
    let params = {
      ApplicationID: this.ApplicationID,
      UserID: this.userInfoService.userData.UserId.toString(),
      Username: this.userInfoService.userData.UserName.toString(),
      //Code: this.token,
      Code: this.loginService.cookieSvc.get("CFSSLoginCode"),
      ProjectID: pProjectID,
      ServerDB: pServerDB,
      LanguageID: this.userInfoService.userData.LanguageId.toString(),
      IsNewMCCLD: true
    };
    return this.httpService.post(SharedService.applicationServiceUrl + SharedService.sService + "RemoveSelectedRecord", params);
  }

  DeleteFolder(pFolderID: number, pParentID: number): Observable<any> {
    let params = {
      ApplicationID: this.ApplicationID,
      UserID: this.userInfoService.userData.UserId.toString(),
      Username: this.userInfoService.userData.UserName.toString(),
      //Code: this.token,
      Code: this.loginService.cookieSvc.get("CFSSLoginCode"),
      FolderID: pFolderID,
      ParentID: pParentID,
      LanguageID: this.userInfoService.userData.LanguageId.toString()
    };
    return this.httpService.post(SharedService.applicationServiceUrl + SharedService.sService + "RemoveApplicationFolder", params);
  }

  assignRecentFilesToNewFolderStruc() {
    let newStructure = [];
    if (this.AllRecentFiles.Files.length > 0) {
      for (let i = 0; i < this.AllRecentFiles.Files.length; i++) {
        var tempRec = {};
        tempRec = this.addToStruc(this.AllRecentFiles.Files[i], "File");
        newStructure.push(tempRec);
      }
    }
    return newStructure;
  }

  addToStruc(WhichRec: any, RecType: string) {
    var NewRec = {};
    switch (RecType) {
      case "Folder":
        NewRec = {
          Fname: WhichRec.FolderName,
          Name: '',
          ID: WhichRec.ID,
          ParentID: WhichRec.ParentID,
          Type: RecType,
          Path: WhichRec.Path,
          ServerDB: WhichRec.ServerDB,
          TimeStamp: WhichRec.TimeStamp,
          TotalFile: WhichRec.TotalFile
        }
        break;

      case "File":
        NewRec = {
          Fname: WhichRec.ProjectName,
          ID: WhichRec.LCCID,
          Name: WhichRec.ProjectName,
          Type: RecType,
          Company: '',
          TimeStamp: WhichRec.TimeStamp,
          AHU: '',
          Solution: '',
          Setup: '',
          Path: WhichRec.Path
        }
        break;
    }
    return NewRec;
  }

  CountTotalSeqForUploadingParams(jData: any, ProcessName: string) {
    if (this.UploadingEntry == false) {
      this.UploadingEntry = true;
      this.TempStringStorageID = "";
      this.TempStringStorageTotalSeq = 0;
      this.TempStringStorageTotalPass = 0;
      this.TempStringStorageTotalFail = 0;
      this.TempStringStorageProcessName = "";
      if (jData != undefined) {
        var strJData = JSON.stringify(jData);
        var totalLength = strJData.length;
        var totalCharUpload = 3072;
        var totalSeq = 1;
        if (totalLength > totalCharUpload) {
          totalSeq = Math.floor(totalLength / totalCharUpload);
          if ((totalLength / totalCharUpload) % 1 > 0) {
            totalSeq = totalSeq + 1;
          }
        }
        this.TempStringStorageProcessName = ProcessName;
        this.TempStringStorageID = this.uuid_new();
        this.TempStringStorageTotalSeq = totalSeq;
        this.TempStringStorageTotalPass = 0;
        this.TempStringStorageTotalFail = 0;
        this.TempStringStorageCurrentSeq = 1;
        this.TempStringStorageStr = strJData;

      }
    }
  }

  generateStr() {
    var totalLength = this.TempStringStorageStr.length;
    var totalCharUpload = 3072;//1024;
    var tStr = "";
    var tStartChar = (this.TempStringStorageCurrentSeq - 1) * totalCharUpload;
    if (this.TempStringStorageCurrentSeq < (this.TempStringStorageTotalSeq)) {
      tStr = this.TempStringStorageStr.substr(tStartChar, totalCharUpload);
    } else {
      tStr = this.TempStringStorageStr.substr(tStartChar, totalLength - tStartChar);
    }

    var tData = {
      ID: this.TempStringStorageID,
      TempString: tStr,
      Seq: this.TempStringStorageCurrentSeq
    };
    return tData;
  }

  uuid_new() {
    return this.p8(1) + this.p8(true) + this.p8(true) + this.p8(1);
  }

  uuid_empty() {
    return '00000000-0000-0000-0000-000000000000';
  }

  p8(s: any) {
    var p = (Math.random().toString(16) + "000000000").substr(2, 8);
    return s ? "-" + p.substr(0, 4) + "-" + p.substr(4, 4) : p;
  }

  CompileDataForCalculation(projectdetails: any, WhichSolution) {
    let Data: any = {};
    Data.ExportType = '';
    Data.CalcType = projectdetails.projectInfo.calculationType;
    Data.GasType = '';
    Data.IsDistributor = false;
    let numberFormat = this.userInfoService.userData.currentLocale;

    if (!isNullOrUndefined(projectdetails.projectInfo)) {
      Data.ProjectInfo = {
        FolderID: projectdetails.projectInfo.folderId,
        ProjectID: projectdetails.projectInfo.id,
        //ProjectName : projectdetails.projectInfo.name,
        ProjectName: projectdetails.projectInfo.projectName,
        ProjectDesc: projectdetails.projectInfo.projectDesc,
        UnitId: projectdetails.projectInfo.unitId,
        ConcUnit: projectdetails.projectInfo.concUnit,
        AirFlowUnit: projectdetails.contamination.airflowUnit,
        ReportDate: projectdetails.projectInfo.projectDate
      };
    }

    //Modified by PP(2023-11-09) : Bugs in project name - START
    // if (Data.ProjectInfo.ProjectName.includes('Untitled Project')) {
    //   if (this.headerProjectName != '') {
    //     Data.ProjectInfo.ProjectName = this.headerProjectName;
    //   }
    // }
    //Modified by PP(2023-11-09) : Bugs in project name - END

    if (!isNullOrUndefined(projectdetails.customerInfo)) {
      Data.CustomerInfo = {
        CustomerCompanyName: projectdetails.customerInfo.customername,
        Contact: projectdetails.customerInfo.contactperson,
        ContactTitle: projectdetails.customerInfo.title,
        ContactStreet: projectdetails.customerInfo.street,
        ContactCity: projectdetails.customerInfo.city,
        ContactState: projectdetails.customerInfo.state,
        ContactCountry: projectdetails.customerInfo.country,
        ContactPhoneNo: projectdetails.customerInfo.contactnum,
        ContactEmail: projectdetails.customerInfo.email
      };
    }

    if (!isNullOrUndefined(projectdetails.siteInfo)) {
      Data.SiteInfo = {
        SiteName: projectdetails.siteInfo.siteName,
        Ahu: projectdetails.siteInfo.ahu,
        Location: projectdetails.siteInfo.location,
        Building: projectdetails.siteInfo.building,
        Room: projectdetails.siteInfo.room,
        Description: projectdetails.siteInfo.siteDesc
      };
    }

    if (!isNullOrUndefined(projectdetails.contamination)) {
      let gasDetArray = [];
      if (projectdetails.contamination.gasDetails !== undefined) {
        for (let i = 0; i < projectdetails.contamination.gasDetails.length; i++) {
          let othergas = {
            OtherContaminationID: projectdetails.contamination.gasDetails[i].otherGasDetails.otherContaminantID,
            OtherContaminationName: projectdetails.contamination.gasDetails[i].otherGasDetails.otherContaminantName,
            ChemicalFormula: projectdetails.contamination.gasDetails[i].otherGasDetails.chemicalFormula,
            Density: this.convertLocaletoNumber(projectdetails.contamination.gasDetails[i].otherGasDetails.density, numberFormat),
            MolecularWeight: this.convertLocaletoNumber(projectdetails.contamination.gasDetails[i].otherGasDetails.molecularWeight, numberFormat),
            BoilingPoint: this.convertLocaletoNumber(projectdetails.contamination.gasDetails[i].otherGasDetails.boilingPoint, numberFormat),
            RefractiveIndex: this.convertLocaletoNumber(projectdetails.contamination.gasDetails[i].otherGasDetails.refractiveIndex, numberFormat),
            VapourPressureValue: this.convertLocaletoNumber(projectdetails.contamination.gasDetails[i].otherGasDetails.vapourPressureValue, numberFormat),
          };
          let moreinformation = {
            ChemicalFormula: projectdetails.contamination.gasDetails[i].moreInformation.chemicalFormula,

            //pplim test
            VapourPressureValue: this.convertLocaletoNumber(projectdetails.contamination.gasDetails[i].moreInformation.vapourPressureValue, numberFormat),
            //VapourPressureValue: 123,

            MolecularWeight: this.convertLocaletoNumber(projectdetails.contamination.gasDetails[i].moreInformation.molecularWeight, numberFormat),
            BoilingPoint: this.convertLocaletoNumber(projectdetails.contamination.gasDetails[i].moreInformation.boilingPoint, numberFormat),
            CasNo: projectdetails.contamination.gasDetails[i].moreInformation.casNo
          };

          let tempdetail = {
            Index: projectdetails.contamination.gasDetails[i].index,
            ChemicalID: projectdetails.contamination.gasDetails[i].chemicalID,
            ContaminationType: projectdetails.contamination.gasDetails[i].contaminationType,
            OtherGas: projectdetails.contamination.gasDetails[i].otherGas,
            ConcentrationValue: this.convertLocaletoNumber(projectdetails.contamination.gasDetails[i].concentrationValue, numberFormat),
            AltConcValue: this.convertLocaletoNumber(projectdetails.contamination.gasDetails[i].altConcValue, numberFormat),
            AltConcUnit: projectdetails.contamination.gasDetails[i].altConcUnit,
            OtherGasDetails: othergas,
            MoreInformation: moreinformation,
            ColorForResultPage: projectdetails.contamination.gasDetails[i].colorForResultPage
          };
          gasDetArray.push(tempdetail);
        }

        Data.Contamination = {
          AirFlow: this.convertLocaletoNumber(projectdetails.contamination.airflow, numberFormat),
          Temperature: this.convertLocaletoNumber(projectdetails.contamination.temperature, numberFormat),
          RelativeHumidity: this.convertLocaletoNumber(projectdetails.contamination.relativeHumidity, numberFormat),
          RunningTime: this.convertLocaletoNumber(projectdetails.contamination.runningTime, numberFormat),
          GasDetails: gasDetArray
          //AirFlowUnit --> refer projectInfo.airflowUnit
        };

        // if (Data.ProjectInfo.AirFlowUnit != "m³/h") {
        //   var newAirFlow = this.calculateService.ConvertAirFlow(Data.ProjectInfo.AirFlowUnit, Data.Contamination.airflowUnit, "m³/h"); 
        //   Data.Contamination.AirFlow = newAirFlow;
        // }

        // switch (projectdetails.projectInfo.UnitId) {
        //   case 1:

        //   break;

        //   case 2:                                  
        //     var newTemperature = this.calculateService.ConvertTemperature(Data.Contamination.Temperature, "SI");                    
        //     Data.Contamination.Temperature = newTemperature;         
        //   break;
        // }
      }
    }

    var pContinue = false; //Modified by PP(2022-09-06) : To cater for Calculated Values in MoreInfo for Results page
    if (!isNullOrUndefined(projectdetails.solutions)) {

      let solutionArray = [];
      for (let i = 0; i < projectdetails.solutions.length; i++) {
        let soldetailArray = [];

        //Modified by PP(2022-09-06) : To cater for Calculated Values in MoreInfo for Results page - START
        if (WhichSolution > 0) {
          if (projectdetails.solutions[i].solutionID == WhichSolution) {
            pContinue = true;
          } else {
            pContinue = false;
          }
        } else {
          pContinue = true;
        }
        //Modified by PP(2022-09-06) : To cater for Calculated Values in MoreInfo for Results page - END

        if (pContinue === true) { //Modified by PP(2022-09-06) : To cater for Calculated Values in MoreInfo for Results page
          for (let j = 0; j < projectdetails.solutions[i].solutionDetails.length; j++) {
            let combinationgasArray = [];
            for (let k = 0; k < projectdetails.solutions[i].solutionDetails[j].combinationGas.length; k++) {
              let tmpcombination = {
                Index: projectdetails.solutions[i].solutionDetails[j].combinationGas[k].index, //Modified by PP(2023-06-07) : Allow same gas diff conc value
                ChemicalID: projectdetails.solutions[i].solutionDetails[j].combinationGas[k].chemicalID,
                ContaminationType: projectdetails.solutions[i].solutionDetails[j].combinationGas[k].contaminationType,
                ConcentrationValue: this.convertLocaletoNumber(projectdetails.solutions[i].solutionDetails[j].combinationGas[k].concentrationValue, numberFormat) //Modified by PP(2023-06-07) : Allow same gas diff conc value
              };
              combinationgasArray.push(tmpcombination);
            }

            let tmpcustomsize = {
              Height: this.convertLocaletoNumber(projectdetails.solutions[i].solutionDetails[j].customMediaSize.height, numberFormat),
              Length: this.convertLocaletoNumber(projectdetails.solutions[i].solutionDetails[j].customMediaSize.length, numberFormat),
              Depth: this.convertLocaletoNumber(projectdetails.solutions[i].solutionDetails[j].customMediaSize.depth, numberFormat),
              ShapeType: projectdetails.solutions[i].solutionDetails[j].customMediaSize.shapeType, //1: rectangle, 2: cylinder - Modified by Pinky(2026-05-12) : To cater for cylinder filter #126174
              Diameter: this.convertLocaletoNumber(projectdetails.solutions[i].solutionDetails[j].customMediaSize.diameter, numberFormat) //Modified by Pinky(2026-05-12) : To cater for cylinder filter #126174
            };

            // switch (projectdetails.projectInfo.unitId) {
            //   case 1:

            //     break;

            //   case 2: //Convert back to SI           
            //     var newHeight = Math.round(tmpcustomsize.Height * 25.4);
            //     var newLength = Math.round(tmpcustomsize.Length * 25.4);
            //     var newDepth = Math.round(tmpcustomsize.Depth * 25.4);

            //     tmpcustomsize.Height = newHeight;
            //     tmpcustomsize.Length = newLength;
            //     tmpcustomsize.Depth = newDepth;
            //     break;
            // }

            let soldetail = {
              CombinationID: projectdetails.solutions[i].solutionDetails[j].combinationID,
              CombinationGas: combinationgasArray,
              MolecularGroup: projectdetails.solutions[i].solutionDetails[j].molecularGroup,
              MolecularGroupID: projectdetails.solutions[i].solutionDetails[j].molecularGroupID,
              MolecularType: projectdetails.solutions[i].solutionDetails[j].molecularType,
              MolecularTypeID: projectdetails.solutions[i].solutionDetails[j].molecularTypeID,
              MolecularID: projectdetails.solutions[i].solutionDetails[j].molecularID,
              MolecularTypeMolecularID: projectdetails.solutions[i].solutionDetails[j].molecularTypeMolecularID,
              FilterName: projectdetails.solutions[i].solutionDetails[j].filterName,
              FilterDBName: projectdetails.solutions[i].solutionDetails[j].filterDBName,
              MolecularPic: projectdetails.solutions[i].solutionDetails[j].molecularPic,
              MolecularTypePic: projectdetails.solutions[i].solutionDetails[j].molecularTypePic,
              InputSize: this.convertLocaletoNumber(projectdetails.solutions[i].solutionDetails[j].inputSize, numberFormat),
              CustomMediaSize: tmpcustomsize,
              NoOfFilter: this.convertLocaletoNumber(projectdetails.solutions[i].solutionDetails[j].noOfFilter, numberFormat),
              TotalStage: this.convertLocaletoNumber(projectdetails.solutions[i].solutionDetails[j].totalStage, numberFormat),
              ASTMWeight: this.convertLocaletoNumber(projectdetails.solutions[i].solutionDetails[j].astmWeight, numberFormat),
              ASTMVolume: this.convertLocaletoNumber(projectdetails.solutions[i].solutionDetails[j].astmvolume, numberFormat)
            };

            //Modified by PP(2023-10-09) : If Filter also removed then id should be zero and not blanks - START
            if (soldetail.MolecularGroupID === '') {
              soldetail.MolecularGroupID = 0;
            }
            if (soldetail.MolecularTypeID === '') {
              soldetail.MolecularTypeID = 0;
            }
            if (soldetail.MolecularID === '') {
              soldetail.MolecularID = 0;
            }
            if (soldetail.MolecularTypeMolecularID === '') {
              soldetail.MolecularTypeMolecularID = 0;
            }
            //Modified by PP(2023-10-09) : If Filter also removed then id should be zero and not blanks - END

            soldetailArray.push(soldetail);
          }

          let tmpsol = {
            SolutionID: projectdetails.solutions[i].solutionID,
            SolutionName: projectdetails.solutions[i].solutionName,
            SolutionDetails: soldetailArray
          };
          solutionArray.push(tmpsol);
        } //Modified by PP(2022-09-06) : To cater for Calculated Values in MoreInfo for Results page


      }
      Data.Solution2Compare = solutionArray;
    }

    //For Report Options
    if (!isNullOrUndefined(projectdetails.reportOptions)) {
      let reportsArray: any = {};
      //let reportsArray = [];
      let rptsArrayBySol = [];
      for (let i = 0; i < projectdetails.reportOptions.ReportInfoBySol.length; i++) {
        let solDetailsArray = [];
        for (let j = 0; j < projectdetails.reportOptions.ReportInfoBySol[i].solDetails.length; j++) {
          if (projectdetails.reportOptions.ReportInfoBySol[i].solDetails[j].molecularGroupID > 0) {
            if (projectdetails.reportOptions.ReportInfoBySol[i].solDetails[j].molecularTypeID > 0) {

              // var tmpLifeTimeHoursFor50Percent = '';
              //  if (projectdetails.results.solutionsResults[i].results[j].LifeTimeHoursFor50Percent != 'NA') {
              //    tmpLifeTimeHoursFor50Percent = this.convertLocaletoNumber(projectdetails.results.solutionsResults[i].results[j].LifeTimeHoursFor50Percent,numberFormat);
              // } else {
              //    tmpLifeTimeHoursFor50Percent = 'NA';
              // }

              let eachSolDet = {
                CombinationID: projectdetails.reportOptions.ReportInfoBySol[i].solDetails[j].combinationID,
                FilterDBName: projectdetails.reportOptions.ReportInfoBySol[i].solDetails[j].filterDBName,
                FilterName: projectdetails.reportOptions.ReportInfoBySol[i].solDetails[j].filterName,
                MolecularGroup: projectdetails.reportOptions.ReportInfoBySol[i].solDetails[j].molecularGroup,
                MolecularGroupID: projectdetails.reportOptions.ReportInfoBySol[i].solDetails[j].molecularGroupID,
                MolecularType: projectdetails.reportOptions.ReportInfoBySol[i].solDetails[j].molecularType,
                MolecularTypeID: projectdetails.reportOptions.ReportInfoBySol[i].solDetails[j].molecularTypeID,
                MolecularID: projectdetails.reportOptions.ReportInfoBySol[i].solDetails[j].molecularID,
                NewFilterGroup: projectdetails.reportOptions.ReportInfoBySol[i].solDetails[j].newFilterGroup,
                NewFilterType: projectdetails.reportOptions.ReportInfoBySol[i].solDetails[j].newFilterType,
                NewMedia: projectdetails.reportOptions.ReportInfoBySol[i].solDetails[j].newMedia,
                LifeTimeHoursFor50Percent: projectdetails.results.solutionsResults[i].results[j].LifeTimeHoursFor50Percent,
                //LifeTimeHoursFor50Percent: tmpLifeTimeHoursFor50Percent,
                LifeTimeHoursFor50PercentForDisplaySign: projectdetails.results.solutionsResults[i].results[j].LifeTimeHoursFor50PercentForDisplaySign,
                ColorForResultPage: projectdetails.results.solutionsResults[i].results[j].colorForResultPage
              }
              solDetailsArray.push(eachSolDet);
            }
          }
        }

        let eachSol = {
          SolDetails: solDetailsArray,
          SolutionID: projectdetails.reportOptions.ReportInfoBySol[i].solutionID,
          SolutionName: projectdetails.reportOptions.ReportInfoBySol[i].solutionName,
        }
        rptsArrayBySol.push(eachSol);
      }

      let rptSettings = {
        ContaminationInformation: projectdetails.reportOptions.reportSettings.contaminationInformation,
        EmailToMe: projectdetails.reportOptions.reportSettings.emailToMe,
        FilterSize: projectdetails.reportOptions.reportSettings.filterSize,
        NumberOfFilter: projectdetails.reportOptions.reportSettings.numberOfFilter,
        WeightOfAdsorbant: projectdetails.reportOptions.reportSettings.weightOfAdsorbant,
        TotalIndicativeWeight: projectdetails.reportOptions.reportSettings.totalIndicativeWeight,
        FrontVelocity: projectdetails.reportOptions.reportSettings.frontVelocity,
        PressureDrop: projectdetails.reportOptions.reportSettings.pressureDrop,
        ContactTime: projectdetails.reportOptions.reportSettings.contactTime
      }

      reportsArray.ReportInfoBySol = rptsArrayBySol;
      reportsArray.ReportSettings = rptSettings;
      reportsArray.ReportsToGenerate = projectdetails.reportOptions.reportsToGenerate;
      reportsArray.GraphSeriesToGenerate = projectdetails.reportOptions.graphSeriesToGenerate;
      Data.ReportOptions = reportsArray;
    }

    return Data;
  }

  formatDateObjTostring(DateType: any, TheDate: any) {
    var tempProjDate = "";
    switch (DateType) {
      case "Object":
        var tempYear = String(TheDate.year);
        var tempMonth = String(TheDate.month).padStart(2, '0');
        var tempDate = String(TheDate.day).padStart(2, '0');
        tempProjDate = tempYear + tempMonth + tempDate;
        break;

      case "String":
        var yyyy = TheDate.getFullYear();
        var mm = String(TheDate.getMonth() + 1).padStart(2, '0');
        var dd = String(TheDate.getDate()).padStart(2, '0');
        tempProjDate = yyyy + mm + dd;
        break;
    }
    return tempProjDate;
  }

  getChildFolders(pFolderID): any {
    let newStructure = [];
    // Folders
    if (this.AllFilesAndFolders.childFolder.length > 0) {
      for (let i = 0; i < this.AllFilesAndFolders.childFolder.length; i++) {
        if (this.AllFilesAndFolders.childFolder[i].ID === pFolderID) {
          for (let x = 0; x < this.AllFilesAndFolders.childFolder[i].childFolder.length; x++) {
            // Add Folder
            var tmpRec = {};
            tmpRec = this.addToStruc(this.AllFilesAndFolders.childFolder[i].childFolder[x], "Folder");
            newStructure.push(tmpRec);
            //Files
            var tempRec = {};
            if (this.AllFilesAndFolders.childFolder[i].childFolder[x].Files !== null) {
              tmpRec = this.addToStruc(this.AllFilesAndFolders.childFolder[i].childFolder[x].Files, "File");
              newStructure.push(tmpRec);
            }
          }
        } else {
          if (this.AllFilesAndFolders.childFolder[i].length > 0) {
            for (let j = 0; j < this.AllFilesAndFolders.childFolder[i].childFolder.length; j++) {
              if (this.AllFilesAndFolders.childFolder[i].childFolder[j].ID === pFolderID) {
                for (let y = 0; y < this.AllFilesAndFolders.childFolder[i].childFolder[j].childFolder.length; y++) {
                  // Add Folder
                  var tmpRec = {};
                  tmpRec = this.addToStruc(this.AllFilesAndFolders.childFolder[i].childFolder[j].childFolder[y], "Folder");
                  newStructure.push(tmpRec);
                  //Files
                  if (this.AllFilesAndFolders.childFolder[i].childFolder[j].childFolder[y].Files) {
                    var tempRec = {};
                    tmpRec = this.addToStruc(this.AllFilesAndFolders.childFolder[i].childFolder[j].childFolder[y].Files, "File");
                    newStructure.push(tmpRec);
                  }
                }
              }
            }
          }
        }
      }
      return newStructure;
    } //if(this.AllFilesAndFolders.childFolder.length >0)
  }

  getDataListPerUserUnit(pUnitID: number) {
    let tmpArray: any;
    tmpArray = this.dataEntriesList;

    switch (pUnitID) {
      case 1:
        tmpArray.AirFlow = this.dataEntriesList.SI_List.AirFlow;
        tmpArray.Temperature = this.dataEntriesList.SI_List.Temperature;
        break;

      case 2:
        tmpArray.AirFlow = this.dataEntriesList.US_List.AirFlow;
        tmpArray.Temperature = this.dataEntriesList.US_List.Temperature;
        break;
    }
    return tmpArray;
  }

  formatValue(data, blnConvertNum) {
    let result: any;
    if (isNullOrEmpty(data)) {
      return;
    }

    let temp = data;
    if (blnConvertNum === true) {
      if (typeof temp !== "number") {
        if (this.userInfoService.userData.NumberFormatId === 1) {
          data = this.convertLocaletoNumber(temp, 'sv-SE');
        } else if (this.userInfoService.userData.NumberFormatId === 2) {
          data = this.convertLocaletoNumber(temp, 'en-US');
        }
        data = data.toString();
      }
    }

    if (/\s/.test(data)) {
      let temp = data;
      data = temp.replace(/\s+/g, "");
    }

    if (!isNullOrUndefinedNumber(this.userInfoService.userData.NumberFormatId)) {
      //Modified by JW(2022-09-30): values of boiling point do not have negative sign and not convert to correct value for unit US-start
      // if(this.userInfoService.userData.NumberFormatId === 1){
      //   let outputSI= parseFloat(data).toLocaleString('sv-SE');
      //   result = outputSI;
      // } else if(this.userInfoService.userData.NumberFormatId === 2) {
      //   var outputUS = parseFloat(data).toLocaleString('en-US');
      //   result = outputUS;
      // }
      let isNegNum = false;
      let dataNum = data;
      if (Math.sign(parseFloat(data)) === -1) {
        isNegNum = true;
        dataNum = Math.abs(data);
      }
      if (this.userInfoService.userData.NumberFormatId === 1) {
        let outputSI = parseFloat(dataNum).toLocaleString('sv-SE');
        if (isNegNum === true) {
          outputSI = '-' + outputSI;
        }
        result = outputSI;
      } else if (this.userInfoService.userData.NumberFormatId === 2) {
        var outputUS = parseFloat(dataNum).toLocaleString('en-US');
        if (isNegNum === true) {
          outputUS = '-' + outputUS;
        }
        result = outputUS;
      }
      //Modified by JW(2022-09-30): values of boiling point do not have negative sign and not convert to correct value for unit US-start-end
    }
    return result;
  }

  convertLocaletoNumber(num, locale) {
    let result: any;
    try {
      if (typeof num === "number") {
        var tmpCost = this.formatValue(num, false);
        num = tmpCost;
      }

      if (num === null) {
        return num = 0;
      }
      if (!isNaN(num)) {
        num = num.toString();
      }
      const { format } = new Intl.NumberFormat(locale);
      const [, decimalSign] = /^0(.)1$/.exec(format(0.1));
      return +num
        .replace(new RegExp(`[^-${decimalSign}\\d]`, 'g'), '')
        .replace(decimalSign, '.');
    } catch (e) {
      console.log(e);
      throwError(e.message);
    }
    result = num;
    return result;
  }

  //Modified by PS(2023-03-21): MCCLD 2023-Fetch Products-START
  /*  getApplicationwithChemicalsList() {
      this.AMCChemical = this.listData.ApplicationContaminationFromServer.AMCChemical;
      this.colContaminationTypeFromServer = this.listData.ApplicationContaminationFromServer.ContaminationType;
      this.ApplicationChemicalList = [{ id: 0, name: 'ALL', chemicalList: this.colContaminationTypeFromServer}];
  
      for (let i = 0; i < this.listData.ApplicationContaminationFromServer.CLDAppChemicalList.length; i++) {
        let temp = this.listData.ApplicationContaminationFromServer.CLDAppChemicalList[i];
        let chemicalList = [];
  
        for (let j = 0; j < temp.ChemicalList.length; j++) {
          let chemicalId = temp.ChemicalList[j];
          let index = this.colContaminationTypeFromServer.findIndex(x => x.ChemicalID === chemicalId);
          if (index > -1) {
            chemicalList.push(this.colContaminationTypeFromServer[index]);
          }
        }
        this.ApplicationChemicalList.push({
          id: temp.ApplicationID,
          name: temp.Application,
          chemicalList: chemicalList
        });
      }
      //this.listData.ApplicationChemicalList = this.ApplicationChemicalList; //Modified by PS(2023-03-21): MCCLD 2023-Fetch Products-START
    }*/
  getApplicationwithChemicalsList() {
    this.AMCChemical = this.ApplicationContaminationFromServer.AMCChemical;
    this.colContaminationTypeFromServer = this.ApplicationContaminationFromServer.ContaminationType;
    this.ApplicationChemicalList = [{ id: 0, name: 'ALL', chemicalList: this.colContaminationTypeFromServer }];

    for (let i = 0; i < this.ApplicationContaminationFromServer.CLDAppChemicalList.length; i++) {
      let temp = this.ApplicationContaminationFromServer.CLDAppChemicalList[i];
      let chemicalList = [];

      for (let j = 0; j < temp.ChemicalList.length; j++) {
        let chemicalId = temp.ChemicalList[j];
        let index = this.colContaminationTypeFromServer.findIndex(x => x.ChemicalID === chemicalId);
        if (index > -1) {
          chemicalList.push(this.colContaminationTypeFromServer[index]);
        }
      }
      this.ApplicationChemicalList.push({
        id: temp.ApplicationID,
        name: temp.Application,
        chemicalList: chemicalList
      });
    }
  }

  getChemInfo(pChemID: number) {
    var chemInfo: any;
    //pplim debug: ??
    let s = JSON.stringify(this.ApplicationContaminationFromServer.AMCChemical)

    for (var x = 0; x < this.ApplicationContaminationFromServer.AMCChemical.length; x++) {
      if (pChemID == this.ApplicationContaminationFromServer.AMCChemical[x].ChemicalID) {

        let s2 = JSON.stringify(this.ApplicationContaminationFromServer.AMCChemical[x])

        chemInfo = {
          contamination_type: this.ApplicationContaminationFromServer.AMCChemical[x].Substance,
          chemical_id: this.ApplicationContaminationFromServer.AMCChemical[x].ChemicalID,
          chemicalFormula: this.ApplicationContaminationFromServer.AMCChemical[x].Formula,

          //pplim debug: ??
          vapourPressureValue: this.ApplicationContaminationFromServer.AMCChemical[x].Vp,
          //vapourPressureValue: 123,

          molecularWeight: this.ApplicationContaminationFromServer.AMCChemical[x].Mw,
          boilingPoint: this.ApplicationContaminationFromServer.AMCChemical[x].Tbp,
          cas_no: this.ApplicationContaminationFromServer.AMCChemical[x].CasNo,
          density: this.ApplicationContaminationFromServer.AMCChemical[x].dL,
          refractiveIndex: this.ApplicationContaminationFromServer.AMCChemical[x].RI,
          chemical_warning: this.ApplicationContaminationFromServer.AMCChemical[x].ChemicalWarning,
          gasWarningColor: parseInt(this.ApplicationContaminationFromServer.AMCChemical[x].Importancy)
        }
        break;
      }
    }

    if (chemInfo == undefined) { //Other Gas
      for (var x = 0; x < this.ApplicationContaminationFromServer.CLDSaveOthersRecord.length; x++) {
        if (pChemID == this.ApplicationContaminationFromServer.CLDSaveOthersRecord[x].ID) {
          chemInfo = {
            contamination_type: this.ApplicationContaminationFromServer.CLDSaveOthersRecord[x].substance,
            chemical_id: this.ApplicationContaminationFromServer.CLDSaveOthersRecord[x].ID,
            chemicalFormula: this.ApplicationContaminationFromServer.CLDSaveOthersRecord[x].formula,
            vapourPressureValue: this.ApplicationContaminationFromServer.CLDSaveOthersRecord[x].vp,
            molecularWeight: this.ApplicationContaminationFromServer.CLDSaveOthersRecord[x].mw,
            boilingPoint: this.ApplicationContaminationFromServer.CLDSaveOthersRecord[x].tbp,
            cas_no: this.ApplicationContaminationFromServer.CLDSaveOthersRecord[x].casno,
            density: this.ApplicationContaminationFromServer.CLDSaveOthersRecord[x].dl,
            refractiveIndex: this.ApplicationContaminationFromServer.CLDSaveOthersRecord[x].ri,
            chemical_warning: '',
            gasWarningColor: 99
          }
          break;
        }
      }
    }
    return chemInfo;
  }
  //Modified by PS(2023-03-21): MCCLD 2023-Fetch Products-END


  UploadFileToServer(filesDropped: any) {
    var msg = "Failed load data from XML file!";
    var fd = new FormData();
    try {
      var url = SharedService.FileUploadURL;
      var name = undefined;
      fd.append('file', filesDropped[0]);
      name = filesDropped[0].name;
    } catch (ex: any) {
      console.log(ex.message);
    }
    return this.httpService.post(SharedService.applicationServiceUrl + SharedService.sMccldService + 'UploadFile', fd).pipe(catchError(this.handleError));
  }

  validate(e) {
    let code = e.key.charCodeAt(0);
    if ((code >= 65 && code <= 90) || (code >= 97 && code <= 122)) {
      e.preventDefault();
      return;
    }

    //Modified by PP(2023-05-11) : Only Integers allowed - START
    var cTarget = e.currentTarget.id;
    if (cTarget.includes('txtNumFil')) {
      if (code < 48 || code > 57) {
        e.preventDefault();
        return;
      }
    }
    //Modified by PP(2023-05-11) : Only Integers allowed - END

    // if (!(code ===44 || code ===46 ||(code >= 48 && code <= 57))) { //44=,  46=. 48 to 57 = 0 to 9
    //   e.preventDefault();
    //   return;
    // }

    if (code === 13) {
      return;
    }
  }

  checkIfZero(event: any) {
    var txtValue = event.target.value;
    var txtValue2 = event.target.valueAsNumber;
    if (txtValue == 0) {
      event.target.value = "";
    }
  }

  focusOut(event: any) {
    var txtValue = event.target.value;
    if (txtValue == "") {
      event.target.value = 0;
    }
  }

  preventTabKey(event: any) {

  }

  ValidateDataEntries(RecFromProjectService) {
    var Data: any = {};
    this.errPage = '';
    if (RecFromProjectService.customerInfo === undefined) {
      this.errPage = "Customer";
      return false;
    }

    if (RecFromProjectService.siteInfo === undefined) {
      this.errPage = "Site Info";
      return false;
    }

    if (RecFromProjectService.contamination === undefined) {
      this.errPage = "Contamination";
      return false;
    }

    if (RecFromProjectService.solutions === undefined) {
      this.errPage = "Solutions";
      return false;
    }
    return true;
  }

  CheckProjExist(projName, projID, pfolderID) {
    let body = {
      ApplicationID: this.ApplicationID,
      UserID: this.userInfoService.userData.UserId.toString(),
      Username: this.userInfoService.userData.UserName.toString(),
      //Code: this.token,
      Code: this.loginService.cookieSvc.get("CFSSLoginCode"),
      FolderID: pfolderID,
      ProjectName: projName,
      ProjectID: projID
    }
    return this.httpService.post(SharedService.applicationServiceUrl + SharedService.sService + 'ProjectNameExistForCFSSApps', body).pipe(catchError(this.handleError));
  }

  //Modified by PP(2023-02-09) : To cater for not getting multi gas alrogrithm - START
  GetMultiGasCalcFlag() {
    let body = {
      ApplicationID: this.ApplicationID,
      UserID: this.userInfoService.userData.UserId.toString(),
      Username: this.userInfoService.userData.UserName.toString(),
      //Code: this.token
      Code: this.loginService.cookieSvc.get("CFSSLoginCode")
    }
    return this.httpService.post(SharedService.applicationServiceUrl + SharedService.sMccldService + 'CheckAllowMultiGasCalculation', body).pipe(catchError(this.handleError));
  }
  //Modified by PP(2023-02-09) : To cater for not getting multi gas alrogrithm - END

  //Modified by PP(2023-10-24): Check for timeout of logincode - START
  checkValidLogin(token: string): Observable<any> {
    let params = { Code: token };
    return this.httpService.post(SharedService.applicationServiceUrl + SharedService.sService + "OnlineAppCheckValidLogin", params);
  }

  redirectToLoginPage() {
    this.userInfoService.userData.UserId = 0;
    this.loginService.cookieSvc.set("CFSSLoginCode", '');
    this.toastr.error('Session time out. Please login again.', '');
    this.router.navigate(["login"]);
  }
  //Modified by PP(2023-10-24): Check for timeout of logincode - END

  async downloadFile(sasUrl: string): Promise<Blob> {
    const response = await fetch(SharedService.applicationServiceUrl + SharedService.sService + 'downloadFile', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ sasUrl })
    });
  
    if (!response.ok) {
      throw new Error('Failed to download file');
    }
  
    return await response.blob();
  }
}
